<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.72863 10.9687C7.92562 10.5814 6.98666 10.5353 6.1349 10.8656C5.1343 11.2535 4.00686 11.1239 3.12034 10.5191L3.00029 10.4372L4.82027 8.97182C5.4393 8.47339 5.87026 7.77912 6.04228 7.00321L6.61002 4.4423L8.56261 4.87517L7.97948 7.50552C7.82405 8.2066 7.88804 8.93853 8.16275 9.602L8.72863 10.9687ZM9.44392 7.83018L10.0271 5.19983L10.5152 5.30805C10.9196 5.39771 11.3201 5.14256 11.4098 4.73816C11.4994 4.33377 11.2443 3.93326 10.8399 3.84361L10.3517 3.73539L10.3517 3.73532L8.88729 3.41066L6.9347 2.97778L5.47025 2.65312L5.47024 2.65319L4.98209 2.54497C4.57769 2.45532 4.17719 2.71047 4.08754 3.11486C3.99788 3.51926 4.25303 3.91976 4.65743 4.00942L5.14558 4.11764L4.57784 6.67855C4.47954 7.12193 4.23327 7.51865 3.87954 7.80347L0.996403 10.1249C0.0856607 10.8582 -0.195144 12.1248 0.32036 13.1743C0.655187 13.856 1.28172 14.3485 2.02318 14.5129L7.92668 15.8217C8.69902 15.9929 9.50731 15.8038 10.1235 15.3076C11.0238 14.5827 11.3385 13.351 10.8963 12.2831L9.54865 9.02817C9.39167 8.64904 9.35511 8.2308 9.44392 7.83018Z"
    fill="currentColor"
  />
  <circle cx="10.25" cy="1.25" r="1.25" fill="currentColor" />
  <circle cx="13.75" cy="3" r="1" fill="currentColor" />
</svg>
